module.exports = __webpack_public_path__ + "img/s3.a19ed50f.jpg";